module.exports = __webpack_public_path__ + "static/media/icon.cec8d3ee.png";